import React from 'react';
import { CheckIcon } from 'lucide-react';
import { bodyAreas, showcaseFeatures } from '../data/content';
import { Eyebrow } from './ui/Section';
export function ProductShowcase() {
  return <section className="bg-slate-50 px-4 py-12 md:py-16" data-id="element-212" data-mp="32luq9svms8pb">
      <div className="mx-auto max-w-4xl text-center" data-id="element-213" data-mp="32ne7blp42ns5">
        <Eyebrow data-id="element-214" data-mp="2xlym9tmxoh9r">The complete 5-volume sports massage system</Eyebrow>
        <h2 className="text-2xl font-black uppercase leading-tight text-blue-950 md:text-4xl" data-id="element-215" data-mp="29wnuv2rh3z8a">
          Complete Sports Massage Bundle
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm font-semibold leading-relaxed text-slate-600 md:text-base" data-id="element-216" data-mp="24yulk0uvip3s">
          Practical professional resources designed for sports massage therapists, qualified bodywork practitioners,
          and manual therapy professionals.
        </p>
        <ul className="mt-4 flex flex-wrap justify-center gap-x-2 gap-y-1 text-xs font-bold uppercase tracking-wide text-blue-700" data-id="element-217" data-mp="3v8xnmhokmddz">
          {bodyAreas.map((area, index) => <li key={area} className="flex items-center gap-2" data-id="element-218" data-mp="24ap4xnmvv6n6" data-mpi={index}>
              {index > 0 && <span className="text-blue-950/30" aria-hidden="true" data-id="element-219" data-mp="298qxcz678ibb">
                  •
                </span>}
              {area}
            </li>)}
        </ul>

        <p className="mt-8 text-left text-xs font-black uppercase tracking-wider text-blue-950 sm:text-center" data-id="element-220" data-mp="2i9oqgmf3n5f4">
          Inside the system:
        </p>
        <ul className="mt-3 grid gap-2.5 text-left sm:grid-cols-2" data-id="element-221" data-mp="1ll8ykjoiojyu">
          {showcaseFeatures.map(item => <li key={item} className="flex items-center gap-3 rounded-xl border border-blue-950/10 bg-white px-4 py-2.5 text-sm font-semibold text-blue-950" data-id="element-222" data-mp="1qgoeri9zyryf">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-blue-700" data-id="element-223" data-mp="1zd75cnura3ru">
                <CheckIcon className="h-3 w-3 text-white" aria-hidden="true" data-id="element-224" data-mp="12rdioe3ldlqm" />
              </span>
              {item}
            </li>)}
        </ul>
      </div>
    </section>;
}